"use client";

import { useEffect, useState } from "react";
import { Table, Popover, Checkbox, Radio, Input, Button } from "antd";
import { Container } from "react-bootstrap";
import Sidebar from "../Sidebar";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";


const AGE_GROUP_OPTIONS = [
  "DTP",
  "Influenza",
  "HPV",
  "TT",
  "Pneumococcal",
  "Meningococcal",
  "MMR",
  "Varicella",
  "Hep A",
  "Hep B",
  "Hib",
  "Yearly",
];

const BRAND_OPTIONS = [
  "Adacel",
  "Boostrix",
  "Serum",
  "Td-Vac",
  "Dual Antigen",
  "Agrippal",
  "FluQuadri",
  "Cervarix",
  "Gardasil",
  "Shan-TT",
  "Tet-Vac",
  "Prevenar",
];

const INITIAL_VACCINES = [
  {
    id: "1",
    name: "Tdap",
    brands: ["Adacel", "Boostrix", "Serum"],    
    daysAfterBirth: 10,
    ageGroup: "DTP",
    dependentOn: "Tetanus",
    dependentDays: 0,
  },
  {
    id: "2",
    name: "DT",
    brands: ["Dual Antigen"],
    daysAfterBirth: 12,
    ageGroup: "DTP",    
    dependentOn: "",
    dependentDays: 0,
  },
  {
    id: "3",
    name: "Influenza 1",
    brands: ["Agrippal", "FluQuadri"],
    daysAfterBirth: 13,
    ageGroup: "Influenza",
    dependentOn: "",
    dependentDays: 0,
  },
];


export default function Vaccines() {
  const [vaccines, setVaccines] = useState(INITIAL_VACCINES);
  const [openPopover, setOpenPopover] = useState("");

  const handleBrandChange = (id, brand) => {
    setVaccines((prev) =>
      prev.map((v) =>
        v.id === id
          ? {
              ...v,
              brands: v.brands.includes(brand)
                ? v.brands.filter((b) => b !== brand)
                : [...v.brands, brand],
            }
          : v
      )
    );
  };

  const handleAgeGroupChange = (id, ageGroup) => {
    setVaccines((prev) =>
      prev.map((v) => (v.id === id ? { ...v, ageGroup } : v))
    );
    setOpenPopover("");
  };

  const handleDaysChange = (id, days) => {
    setVaccines((prev) =>
      prev.map((v) => (v.id === id ? { ...v, dependentDays: days } : v))
    );
  };

  const columns = [
    {
      title: "Vaccine Name",
      dataIndex: "name",
      width: 150,
    },
    {
      title: "Brands",
      render: (_, record) => (
        <Popover
          trigger="click"
          open={openPopover === `brands-${record.id}`}
          onOpenChange={(open) =>
            setOpenPopover(open ? `brands-${record.id}` : "")
          }
          content={
            <div style={{ maxHeight: 250, overflowY: "auto" }}>
              {BRAND_OPTIONS.map((brand) => (
                <div key={brand} style={{ marginBottom: 6 }}>
                  <Checkbox
                    checked={record.brands.includes(brand)}
                    onChange={() => handleBrandChange(record.id, brand)}
                  >
                    {brand}
                  </Checkbox>
                </div>
              ))}
            </div>
          }
        >
          <Button className="w-50 text-start">
            {record.brands.length
              ? record.brands.join(", ")
              : "Select brands..."}
          </Button>
        </Popover>
      ),
    },
    {
      title: "Days After Birth",
      width: 150,
      render: (_, record) => (
        <Input
          value={record.daysAfterBirth}
          readOnly
          style={{ width: 80, textAlign: "center" }}
        />
      ),
    },
    {
      title: "Age Group",
      width: 150,
      render: (_, record) => (
        <Popover
          trigger="click"
          open={openPopover === `age-${record.id}`}
          onOpenChange={(open) =>
            setOpenPopover(open ? `age-${record.id}` : "")
          }
          content={
            <Radio.Group
              value={record.ageGroup}
              onChange={(e) => handleAgeGroupChange(record.id, e.target.value)}
            >
              {AGE_GROUP_OPTIONS.map((opt) => (
                <Radio
                  key={opt}
                  value={opt}
                  style={{ display: "block", margin: "4px 0" }}
                >
                  {opt}
                </Radio>
              ))}
            </Radio.Group>
          }
        >
          <Button className="w-100 text-start">
            {record.ageGroup || "Select..."}
          </Button>
        </Popover>
      ),
    },
    {
      title: "Dependent On",
      width: 150,
      render: (_, record) => (
        <div
          style={{
            background: "#e5e7eb",
            padding: "6px 10px",
            borderRadius: 4,
            color: "#9ca3af",
          }}
        >
          {record.dependentOn || "Depend..."}
        </div>
      ),
    },
    {
      title: "Dependent Days",
      width: 150,
      render: (_, record) => (
        <Input
          type="number"
          value={record.dependentDays}
          onChange={(e) =>
            handleDaysChange(record.id, Number(e.target.value) || 0)
          }
          style={{ width: 90, textAlign: "center" }}
        />
      ),
    },
  ];
    useEffect(() => {
    const sidebar = document.getElementById("sidebar");
    if (sidebar) {
      sidebar.classList.add("sidebar-doctor");
      sidebar.id = "menu-item1"; // Change ID if needed
    }
    
      document.body.classList.remove("expand-menu");
      document.body.classList.add("mini-sidebar");

  }, []);
  return (
    <>
      <div>
        <Sidebar id="menu-item1" id1="menu-items1" activeClassName="symptoms" />
        <div className="page-wrapper-doctor">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#">Doctor&apos;s Setting </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Symptoms</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <Container fluid className="p-0">
                {/* Header */}
                <div
                  style={{
                    background: "#3b82f6",
                    color: "#fff",
                    padding: "16px 24px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <h3 className="m-0">Settings</h3>
                  <Button type="link" style={{ color: "#dbeafe" }}>
                    Save Changes
                  </Button>
                </div>

                {/* Table */}
                <div style={{ background: "#f9fafb", padding: 24 }}>
                  <Table
                    columns={columns}
                    dataSource={vaccines}
                    rowKey="id"
                    pagination={false}
                    bordered={false}
                  />
                </div>

                {/* Footer */}
                <div
                  style={{
                    background: "#f9fafb",
                    padding: 16,
                    textAlign: "center",
                    borderTop: "1px solid #d1d5db",
                    borderRadius: "0 0 8px 8px",
                  }}
                >
                  <Button type="link" style={{ fontWeight: 600 }}>
                    + Add
                  </Button>
                </div>
              </Container>
            </div>
          </div>
        </div>
        {/* Delete Modal */}
        {/* <div
            id="delete_patient"
            className="modal fade delete-modal"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <img src={imagesend} alt="#" width={50} height={46} />
                  <h3>Are you sure want to delete this?</h3>
                  <div className="m-t-20">
                    <Link
                      to="#"
                      className="btn btn-white me-2"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </Link>
                    <button type="submit" className="btn btn-danger">
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
      </div>
    </>
  );
}
